var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReviewIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11,
    height: 13,
    viewBox: "0 0 11 13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    "data-name": "Layer 3",
    transform: "translate(-6.5 -5.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M7.5,16v1.5H7a.5.5,0,0,0,0,1H17a.5.5,0,0,0,0-1h-.5V16a4.489,4.489,0,0,0-2.482-4A4.489,4.489,0,0,0,16.5,8V6.5H17a.5.5,0,0,0,0-1H7a.5.5,0,0,0,0,1h.5V8a4.489,4.489,0,0,0,2.482,4A4.489,4.489,0,0,0,7.5,16Zm1-8V6.5h7V8a3.5,3.5,0,1,1-7,0ZM12,12.5A3.5,3.5,0,0,1,15.5,16v1.5h-7V16A3.5,3.5,0,0,1,12,12.5Z",
    fill: "#d28c00"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReviewIcon);
export default __webpack_public_path__ + "static/media/review_icon.b56810162dfe1c3f383a71439000bf4a.svg";
export { ForwardRef as ReactComponent };